module.exports = __webpack_public_path__ + "static/media/bQuiz.45d3e6d2.svg";